import * as React from 'react';
import {useState} from 'react';
import {FormattedMessage} from 'react-intl';

import {IContentBlock} from 'features/blocks/types';
import {Margin, ParagraphSize, HeadlineLevel} from 'features/ui/enums';
import {useDeviceStore, selectIsMobile} from 'features/ui/store/useDeviceStore';
import {stringToId} from 'features/services/utils/string-helpers';

import 'components/blocks/FAQ/FaqSectionBlock/style.scss';

import {P} from '@atoms/Text/P';
import {ButtonLink} from '@atoms/LinksAndButtons/ButtonLink';
import {FaqQuestionBlock} from 'components/blocks/FAQ/FaqQuestionBlock';
import { ButtonColor, ButtonSize, ButtonType } from '@atoms/LinksAndButtons/Button';
import {Headline} from '@atoms/Text/Headline';

export interface FaqSectionBlockType {
    header: string;
    content: string;
    contentHeadline?: string;
    contentMeta?: string;
    customButtonText?: string;
    faqQuestions: IContentBlock<any>[]; // eslint-disable-line @typescript-eslint/no-explicit-any -- polymorphic block dispatch
    link?: string;
    linkText?: string;
}

interface Props extends IContentBlock<FaqSectionBlockType> {
    noReadMore?: boolean;
}

export const FaqSectionBlock: React.FunctionComponent<Props> = (props) => {
    const [_isOpen, _setIsOpen] = useState<boolean>(false);
    const sectionId = props.id ? props.id : `section-${stringToId(props.data.header)}`;

    const isMobile = useDeviceStore(selectIsMobile);

    return (
        <div className="faq-section-block" id={sectionId}>

            {props.data.header &&
                <Headline level={HeadlineLevel.H3} center={isMobile} margin={Margin.L}>{props.data.header}</Headline>
            }

            <div className="faq-section-block__questions">
                {props.data.faqQuestions.map((question, index) => (
                    <FaqQuestionBlock {...question} questionId={sectionId + "-" + index} key={`question-${index}`} />
                ))}
            </div>
            {props.data.link && !props.noReadMore &&
                <div className="faq-section-block__more">
                    {props.data.contentHeadline &&
                        <Headline level={HeadlineLevel.H4} center>{props.data.contentHeadline}</Headline>
                    }
                    {props.data.content &&
                        <P center size={!isMobile ? ParagraphSize.L : undefined}>
                            {props.data.content}
                        </P>
                    }
                    {props.data.contentMeta &&
                        <P center>
                            {props.data.contentMeta}
                        </P>
                    }
                    {props.data.link &&
                        <ButtonLink 
                            href={props.data.link} 
                            buttonColor={ButtonColor.DEFAULT} 
                            buttonSize={ButtonSize.WIDE} 
                            buttonType={ButtonType.GHOST} 
                        >
                            { props.data.customButtonText ? props.data.customButtonText :  props.data.linkText ? props.data.linkText : <FormattedMessage id="jm.components.FaqSectionBlock.seeAll" /> }
                        </ButtonLink>
                    }
                </div>
            }
        </div>
    );
};

